module.exports = __webpack_public_path__ + "static/media/21ECLAC8.70b2ac7e.jpg";